import {
  Button,
  Div,
  Flex,
  Icon as QIcon,
  Text,
} from '@sendoutcards/quantum-design-ui'
import React, { useLayoutEffect } from 'react'
import {
  useActions,
  useCallback,
  useEffect,
  useQueryParams,
  useSelector,
  useSponsorFromQueryParam,
  useState,
} from 'src/hooks'
import {
  activePlans,
  legacyPlans,
  tableFeatures,
} from 'src/points_conversion/data/pointsConversionData'
import {
  ActivePlan,
  FeatureType,
  PlanData,
} from 'src/points_conversion/data/type'
import PlanUpsale from 'src/plan_upsale/PlanUpsale'
import { PricingRoute } from '../marketing/plans/routes/PricingRoute'
import { GreetingCardCarousel } from './components/GreetingCardCarousel'
import { GlassBackgroundContainer } from './components/GlassBackground'
import { ExternalTogglePill } from './components/ExternalTogglePill'
import { PlanTiles } from 'src/pricing_page/components/pricingTile/PlanTiles'
import { ContentBlock } from './components/ContentBlock'
import { FeatureItemChart } from './components/featureChart/FeatureChart'
import { DialogUpsaleCheckout } from 'src/upsale/components/checkout/DialogUpsaleCheckout'
import { AddOnTiles } from 'src/pricing_page/components/addOnTile/AddOnTiles'
import { LegacyPlanTile } from './components/legacyPlanTile/LegacyPlan'
import { PromoPlanTile } from './components/promoPlanTile/PromoPlanTile'
import { navigateAndScroll } from './utils'
import { BlobType, SectionContainer } from './components/SectionContainer'
import { ComparisonChart } from './ComparisonChart'
import { FeatureCardGridSection } from './FeatureCardGridSection'
import { SubscriptionCheckout } from 'src/saleor/components/subscription_checkout/SubscriptionCheckout'
import { ShoppingCart } from 'src/saleor/components/shopping_cart/ShoppingCart'
import {
  SinglePlanTile,
  supportedAffiliateCountries,
} from './components/singlePlanTile/SinglePlanTile'
import { PRICING_CONTEXT } from 'src/context/types'
import useAddProductFromQueryParam from './hooks/useAddProductFromQueryParam'
import { browserHistory } from 'src/redux/browserHistory'
import {
  PlanFragment,
  StripeSubscriptionFragment,
} from 'src/graphql/generated/graphql'
import { usePlans, usePricingPage } from 'src/react_query'
import { AFFILIATE_BRANDING } from 'src/app/constants'
import { getPlanDescriptions } from 'src/saleor/utils/getPlanDescriptions'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { motion, AnimatePresence } from 'framer-motion'
import useHandleProductActions from 'src/pricing_page/hooks/useHandleProductActions'
import { Section } from 'src/pricing_page/components/layout/Section'
import { SectionHeader } from 'src/pricing_page/components/layout/SectionHeader'
import lottie, { AnimationItem } from 'lottie-web'
import instantImpactAnimation from './assets/animated_svg/instant-impact.json'
import lastingKeepsakeAnimation from './assets/animated_svg/lasting-keepsake.json'
import widerReachAnimation from './assets/animated_svg/wider-reach.json'
import innerGrowthAnimation from './assets/animated_svg/inner-growth.json'
import instantImpactImage from './assets/images/InstantImpact-Pic.png'
import lastingKeepsakeImage from './assets/images/LastingKeepsake-Pic.png'
import widerReachImage from './assets/images/WiderReach-Pic.png'
import innerGrowthImage from './assets/images/InnerGrowth.Pic.png'
import instantImpactTextImage from './assets/animated_svg/InstantImpact-text.svg'
import lastingKeepsakeTextImage from './assets/animated_svg/LastingKeepsake-text.svg'
import widerReachTextImage from './assets/animated_svg/WiderReach-text.svg'
import innerGrowthTextImage from './assets/animated_svg/InnerGrowth-text.svg'

const PRICING_SECTION_MAX_WIDTH = '1600px'
const CURRENT_LEGACY_PLAN_IDS = [
  '4',
  '39',
  '40',
  '42',
  '43',
  '121',
  '122',
  '123',
  '124',
  '125',
  '126',
  '127',
  '128',
  '129',
]

const ribbonCards = [
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/0MNyTUIJ59tbLBw2n9ubQZKcM7s=/fit-in/700x0/system_images/2023/4/5/5c83f228-2278-4325-84c6-9999a9220704.png',
    isHorizontal: true,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/mXeM5PvgvIUfJ_jWCNo0_cQzPAM=/fit-in/700x0/system_images/2022/11/18/122f2557-5498-4f88-84cd-c47024a257b8.png',
    isHorizontal: false,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/Ull0NhiMOHHuQ3fe8K7OlNlR2PQ=/fit-in/320x0/system_images/2021/10/5/e3a7189e-454c-4930-8d7e-6b2900a72cc9.png',
    isHorizontal: true,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/em2a3lTin6EyFlIzq2aCPTlHTiQ=/fit-in/320x0/system_images/2025/5/6/72c53ee3-f923-48e4-8ff1-d3a45fb7fef9.png',
    isHorizontal: false,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/Sd4KK5Qy_K8ms572AqSysfbhxtQ=/fit-in/700x0/system_images/2022/2/18/c7105cf9-fd46-46cb-a1aa-e2895150ce1a.png',
    isHorizontal: true,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/L4ACmmJ1pEV3zJ-C0AhS4P9scsE=/fit-in/320x0/system_images/2020/5/18/d7bf2927-8684-4203-bd6b-ff9d3947d7d9.png',
    isHorizontal: false,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/plELQYxjJDKX13xIn01icv1iE4k=/fit-in/700x0/system_images/2025/6/11/cf0c252a-5a0a-41bd-b970-d0a3158f162a.png',
    isHorizontal: true,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/UDHUMqJ8FYkonW2Q57TXLQXq_ig=/fit-in/700x0/system_images/2020/8/12/72a5494b-eb28-4315-a839-9122af89a465.png',
    isHorizontal: false,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/0F2c_sYzVLRz9gYGid4o5W1tBtA=/fit-in/700x0/system_images/2019/12/4/0fab54d8-4b71-4923-89da-a257e7c182ce.png',
    isHorizontal: true,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/-wrSVB3KmUyY4CtKeuq3kYaB83Q=/fit-in/700x0/system_images/2024/1/18/d88aab2b-6d3f-408f-994a-7363960013b4.png',
    isHorizontal: false,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/LEbWCaCMaivyIbSNCpKSFNuOdRg=/fit-in/700x0/system_images/2020/11/13/fa24ba10-b7a7-4f9c-9dfd-6b7c73ff990d.png',
    isHorizontal: true,
  },
  {
    previewUrl:
      'https://www.sendoutcards.com/thumbnail/KYdvdBAa1Z-wR4f_FS7s6NWbsl4=/fit-in/700x0/system_images/2025/3/19/f9b09346-f216-4ff0-abc5-0046e3a3f85a.png',
    isHorizontal: false,
  },
]

type PricingPageProps = {
  route?: PricingRoute
}

const STARTER_PACKAGE_LABEL = 'Starter Package'
const GRATITUDE_PACK_100_LABEL = 'Gratitude Pack 100'
const GRATITUDE_CONSULTANT_GRADIENT =
  'linear-gradient(65deg,#E56B7E 0%, #A168E9 50%, #67B0FF 100%)'
const FALLBACK_STARTER_GRADIENT =
  'linear-gradient(65deg,#10B981 0%, #3B82F6 50%, #6366F1 100%)'

const GRATITUDE_IMPACT_TILES = [
  {
    id: 'instant_impact',
    title: 'Instant Impact',
    description: 'Digital ACTs & Gifts',
  },
  {
    id: 'lasting_keepsake',
    title: 'Lasting Keepsake',
    description: 'Printed Cards & Gifts',
  },
  {
    id: 'wider_reach',
    title: 'Wider Reach',
    description: 'System Cards & Expert Help',
  },
  {
    id: 'inner_growth',
    title: 'Inner Growth',
    description: 'Journals & Training',
  },
]

export const PricingPage: React.FC<PricingPageProps> = ({ route }) => {
  const actions = useActions()
  const account = useSelector(state => state.user.account)
  const context = useSelector(state => state.context)
  const isCheckoutOpen =
    context.kind === PRICING_CONTEXT ? context.isCheckoutOpen : false
  const isInAffiliateCountry =
    account &&
    supportedAffiliateCountries.some(
      country => country.name === account.shippingAddress?.country,
    )

  const isInIncognitoCountry = account && !account.shippingAddress
  const shouldDisplayAffiliateBanner =
    !account || isInAffiliateCountry || isInIncognitoCountry
  const hasEverHadSamplePack = account && account.hasEverHadSamplePack

  const { selected: selectedPlanId, removeQueryParams } = useQueryParams()
  const { data: plans } = usePlans()
  const saleorPlanDescriptions = plans ? getPlanDescriptions(plans) : {}
  const { addToCart } = useHandleProductActions()
  const { data: pages } = usePricingPage()
  useAddProductFromQueryParam()

  const allPlans = { ...legacyPlans, ...activePlans }
  const [shouldOpenPlanUpsale, setShouldOpenPlanUpsale] = useState(false)
  const [selPlan, setSelPlan] = useState<PlanFragment | undefined>(undefined)
  const [shouldShowComparisonChart, setShouldShowComparisonChart] =
    useState(false)
  const shouldShowGratitudePacks = true
  const shouldHideFreeCard =
    (process.env.REACT_APP_HIDE_FREE_CARD_SECTION ?? 'true') === 'true'
  const shouldHideStarterPackage = true

  const [isHovered, setIsHovered] = useState(false)
  const [showHeroExclusiveFeatures, setShowHeroExclusiveFeatures] =
    useState(false)
  const heroToggleRef = React.useRef<HTMLDivElement | null>(null)
  const heroPrevTopRef = React.useRef<number | null>(null)
  const heroPendingRef = React.useRef(false)
  const instantImpactRef = React.useRef<HTMLDivElement | null>(null)
  const lastingKeepsakeRef = React.useRef<HTMLDivElement | null>(null)
  const widerReachRef = React.useRef<HTMLDivElement | null>(null)
  const innerGrowthRef = React.useRef<HTMLDivElement | null>(null)
  const [shouldShowAllHeroPlans, setShouldShowAllHeroPlans] = useState(false)
  const [showMoreChevronBurst, setShowMoreChevronBurst] = useState(false)
  const [showExclusiveChevronBurst, setShowExclusiveChevronBurst] =
    useState(false)
  const heroToggleAnimationTimer = React.useRef<number | null>(null)
  const heroExclusiveAnimationTimer = React.useRef<number | null>(null)
  const heroToggleScrollTimer = React.useRef<number | null>(null)

  useEffect(() => {
    return () => {
      if (heroToggleAnimationTimer.current) {
        window.clearTimeout(heroToggleAnimationTimer.current)
      }
      if (heroExclusiveAnimationTimer.current) {
        window.clearTimeout(heroExclusiveAnimationTimer.current)
      }
      if (heroToggleScrollTimer.current) {
        window.clearTimeout(heroToggleScrollTimer.current)
      }
    }
  }, [])

  const currentPlanId = account?.plan.id
  const isPlanLegacy = CURRENT_LEGACY_PLAN_IDS.find(l => l === currentPlanId)
  const affiliateSubscription = account?.subscriptions.find(
    (sub: StripeSubscriptionFragment) =>
      sub.sku === 'GS00001' || sub.sku === 'GS00012',
  )

  const hasAffiliateSubscription =
    (affiliateSubscription && !affiliateSubscription.isSetToCancel) ?? false
  const [selectedPlanData, setSelectedPlanData] = useState<
    PlanData<ActivePlan>
  >(activePlans[ActivePlan.HRFLT])

  const isSubscription =
    selectedPlanData.id === allPlans['Heartfelt Subscription'].id ||
    selectedPlanData.id === allPlans['Heartfelt Plus Gifts Subscription'].id ||
    selectedPlanData.id === allPlans['Heartfelt Plus Subscription'].id

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const removeSelected = useCallback(() => removeQueryParams(['selected']), [])
  const { sponsor } = useSponsorFromQueryParam()

  useEffect(() => {
    if (selectedPlanId && selectedPlanId !== currentPlanId) {
      const queryParamPlan = plans?.find(value => value.id === selectedPlanId)
      if (queryParamPlan) {
        setSelPlan(queryParamPlan)
        removeSelected()
      }
    }
  }, [
    selectedPlanId,
    currentPlanId,
    plans,
    setSelPlan,
    actions,
    removeSelected,
  ])

  const page = pages?.find(page => page.id === '4')
  const isComparisonChartEnabled = page?.id === '1'

  const filteredPlanSections = page?.sections.filter(
    section => section.plantilesection,
  )

  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    const decodedHash = decodeURIComponent(hash)

    const expectedStore = 'pricing'

    const searchParams = new URLSearchParams(window.location.search)
    const store = searchParams.get('store')

    if (store !== expectedStore) {
      searchParams.delete('checkout')
      searchParams.delete('store')
      searchParams.append('store', expectedStore)
      const newUrl = `${window.location.pathname}?${searchParams.toString()}`
      browserHistory.push(newUrl)
      // Window popstate event doesn't trigger when history state changes so we dispatch a custom event
      // See Checkout context for this event listener
      window.dispatchEvent(new Event('update_checkout'))
    }
    if (decodedHash) {
      navigateAndScroll(decodedHash)
    }
  }, [])

  useEffect(() => {
    return () => {
      if (heroToggleAnimationTimer.current) {
        window.clearTimeout(heroToggleAnimationTimer.current)
      }
    }
  }, [])

  const filteredGridSections = page?.sections.filter(
    section => section.pricinggrid,
  )

  const starterSection = filteredPlanSections?.find(
    section => section.plantilesection?.title === 'Add To Your Membership:',
  )

  const starterSectionPlanIds = starterSection?.plantilesection?.planIds ?? []

  const starterPlanIdFromDescriptions =
    starterSectionPlanIds.find(planId => {
      const description = saleorPlanDescriptions[planId.id]
      return description?.plan === STARTER_PACKAGE_LABEL
    }) ?? starterSectionPlanIds[0]

  const starterPlanId = starterPlanIdFromDescriptions?.id

  const starterPlan =
    starterPlanId && plans
      ? plans.find(plan => plan.id === starterPlanId)
      : undefined

  const starterPlanGradient =
    starterPlan &&
    starterPlan.backgroundStartColor &&
    starterPlan.backgroundEndColor
      ? `linear-gradient(65deg,${starterPlan.backgroundStartColor} 0%, ${starterPlan.backgroundEndColor} 100%)`
      : FALLBACK_STARTER_GRADIENT

  const gratitudePack100PlanIdFromName = filteredPlanSections
    ?.flatMap(section => section.plantilesection?.planIds ?? [])
    .find(planId => {
      const description = saleorPlanDescriptions[planId.id]
      return description?.plan === GRATITUDE_PACK_100_LABEL
    })?.id

  const gratitudePack100PlanIdFromStarterSection = starterSectionPlanIds.find(
    planId => planId.id !== starterPlanId,
  )?.id

  const gratitudePack100PlanId =
    gratitudePack100PlanIdFromName ?? gratitudePack100PlanIdFromStarterSection

  const createBoldSentence = (sentence: string) => {
    const words = sentence.trim().split(' ')
    const lastWord = words[words.length - 1]
    const trimmedSentence = words.slice(0, -1).join(' ')
    return { title: trimmedSentence, bolded: lastWord }
  }

  const generateSectionId = (sectionOrder: number) => {
    return `${sectionOrder + 1}`
  }

  const impactTileImages: Record<string, string> = {
    instant_impact: instantImpactImage,
    lasting_keepsake: lastingKeepsakeImage,
    wider_reach: widerReachImage,
    inner_growth: innerGrowthImage,
  }

  const impactTileTextImages: Record<string, string> = {
    instant_impact: instantImpactTextImage,
    lasting_keepsake: lastingKeepsakeTextImage,
    wider_reach: widerReachTextImage,
    inner_growth: innerGrowthTextImage,
  }

  const isTablet = useSelector(state => state.window.width < 950)
  const isMobile = useSelector(state => state.window.width <= 520)
  const shouldStackPromoTile = useSelector(state => state.window.width <= 840)
  const shouldUseTwoColumnImpactTiles = useSelector(
    state => state.window.width <= 1256 && state.window.width > 520,
  )
  const heroToggleStickyTop = isMobile ? '72px' : '96px'
  const toggleScrollDelay = isMobile ? 260 : 420
  const scrollToggleIntoView = ({
    delay = 0,
    align = 'bottom',
    offset = 36,
  }: { delay?: number; align?: 'bottom' | 'top'; offset?: number } = {}) => {
    if (!isMobile || !heroToggleRef.current) return
    if (heroToggleScrollTimer.current) {
      window.clearTimeout(heroToggleScrollTimer.current)
    }
    heroToggleScrollTimer.current = window.setTimeout(() => {
      window.requestAnimationFrame(() => {
        const rect = heroToggleRef.current!.getBoundingClientRect()
        const targetScroll =
          align === 'top'
            ? window.scrollY + rect.top - offset
            : window.scrollY +
              rect.top -
              (window.innerHeight - rect.height - offset)
        window.scrollTo({
          top: Math.max(targetScroll, 0),
          behavior: 'smooth',
        })
      })
    }, delay)
  }

  const heroPlanTiles = filteredPlanSections?.[0]

  const heroSectionFeatureChart = heroPlanTiles?.plantilesection?.featureChart
    ? JSON.parse(heroPlanTiles.plantilesection.featureChart)
    : null

  const addOnTileIds = [{ id: '141' }, { id: '142' }, { id: '143' }]

  const shouldShowSuggestedAffiliateInCart =
    hasAffiliateSubscription && shouldDisplayAffiliateBanner

  useLayoutEffect(() => {
    if (!heroPendingRef.current) return
    heroPendingRef.current = false
    const el = heroToggleRef.current
    if (!el || heroPrevTopRef.current == null) return
    const newTop = el.getBoundingClientRect().top
    const delta = newTop - heroPrevTopRef.current
    if (Math.abs(delta) > 0.5) {
      window.scrollBy({ top: delta, left: 0 })
    }
    heroPrevTopRef.current = null
  }, [showHeroExclusiveFeatures, shouldShowAllHeroPlans])

  useEffect(() => {
    let instantAnimation: AnimationItem | undefined
    let keepsakeAnimation: AnimationItem | undefined
    let widerReachAnimationInstance: AnimationItem | undefined
    let innerGrowthAnimationInstance: AnimationItem | undefined

    if (instantImpactRef.current) {
      instantAnimation = lottie.loadAnimation({
        container: instantImpactRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: instantImpactAnimation as unknown as object,
      })
    }

    if (lastingKeepsakeRef.current) {
      keepsakeAnimation = lottie.loadAnimation({
        container: lastingKeepsakeRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: lastingKeepsakeAnimation as unknown as object,
      })
    }

    if (widerReachRef.current) {
      widerReachAnimationInstance = lottie.loadAnimation({
        container: widerReachRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: widerReachAnimation as unknown as object,
      })
    }

    if (innerGrowthRef.current) {
      innerGrowthAnimationInstance = lottie.loadAnimation({
        container: innerGrowthRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: innerGrowthAnimation as unknown as object,
      })
    }

    return () => {
      instantAnimation?.destroy()
      keepsakeAnimation?.destroy()
      widerReachAnimationInstance?.destroy()
      innerGrowthAnimationInstance?.destroy()
    }
  }, [])

  return (
    <Flex
      width="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      overflow="hidden"
      backgroundColor="#fcfcfc"
      rowGap="x3"
    >
      <Div
        position="fixed"
        zIndex={400}
        top={isMobile ? '56px' : '65px'}
        right={isTablet ? '8px' : '40px'}
      >
        <ShoppingCart
          onProceed={() => {
            actions.checkoutOpenState(true)
          }}
          planAddon={
            !shouldShowSuggestedAffiliateInCart
              ? {
                  sku: 'GS00018',
                  variantId: 'UHJvZHVjdFZhcmlhbnQ6NTA1',
                }
              : undefined
          }
        />
      </Div>
      <SubscriptionCheckout
        isOpen={!!isCheckoutOpen}
        setIsOpen={actions.checkoutOpenState}
      />
      {page && (
        <>
          <GlassBackgroundContainer
            blobStart="center"
            blobs={page?.uiBlobs ? JSON.parse(page?.uiBlobs) : []}
          >
            {/* -------- Hero Container | Brand + Intro ---------- */}
            <Section
              maxWidth={PRICING_SECTION_MAX_WIDTH}
              horizontalInset={isMobile ? 'x1_5' : isTablet ? 'x2' : 'x4'}
              verticalInset={isMobile ? 'x2' : 'x3'}
            >
              <SectionHeader eyebrow={page.heroTitle} title={''} />
              <Flex
                width="100%"
                justifyContent="center"
                alignItems="center"
                outset={{ vertical: isMobile ? 'x0' : 'x1' }}
              >
                <Icon name={'promptings_powered_by_soc_logo'} />
              </Flex>
              <Text
                outset="x2"
                type={isMobile ? 'caption' : 'largeBody'}
                content={page.heroDescription}
                style={{ fontSize: isTablet ? 14 : 16, color: '#404040' }}
                alignment="center"
              />
            </Section>
            {isMobile ? (
              <Flex justifyContent="center" alignItems="center" width="100%">
                <GreetingCardCarousel cards={ribbonCards} />
              </Flex>
            ) : (
              <Section
                maxWidth={PRICING_SECTION_MAX_WIDTH}
                verticalInset={window.innerWidth <= 756 ? 'x0' : 'x2'}
              >
                <Flex justifyContent="center" alignItems="center" width="100%">
                  <GreetingCardCarousel cards={ribbonCards} />
                </Flex>
              </Section>
            )}
            {/* -------- Subscriptions ---------- */}
            {heroPlanTiles && heroPlanTiles.plantilesection && (
              <>
                <Section maxWidth="1600px" verticalInset="x3">
                  <ContentBlock
                    caption={heroPlanTiles.plantilesection.title}
                    title={createBoldSentence(
                      heroPlanTiles.plantilesection?.subtitle,
                    )}
                    body={[heroPlanTiles.plantilesection.description]}
                  />
                  <Flex
                    justifyContent="center"
                    id={generateSectionId(heroPlanTiles.plantilesection.order)}
                    width="100%"
                    overflow="visible"
                    alignItems="center"
                    style={{
                      scrollbarWidth: 'thin',
                      scrollbarColor: '#888 transparent',
                    }}
                    inset={{ top: isMobile ? '24px' : '44px' }}
                  >
                    <PlanTiles
                      planIds={heroPlanTiles.plantilesection.planIds}
                      onSelect={(plan: PlanFragment) => setSelPlan(plan)}
                      onProceedToCheckout={() =>
                        actions.checkoutOpenState(true)
                      }
                      layout="grid"
                      initialMobileElement={5}
                      showBasicPlan={shouldShowAllHeroPlans}
                      showProPlan={shouldShowAllHeroPlans}
                      shouldAnimateOnExpand
                      animationKey={shouldShowAllHeroPlans ? 'all' : 'limited'}
                    />
                  </Flex>
                </Section>
                {heroSectionFeatureChart && (
                  <Section
                    maxWidth={PRICING_SECTION_MAX_WIDTH}
                    verticalInset="x3"
                  >
                    <Flex
                      cursor="pointer"
                      onClick={() => {
                        if (typeof window !== 'undefined') {
                          const sponsorQuery = sponsor
                            ? `?sponsor=${sponsor.genealogyId.toString()}`
                            : ''
                          window.open(
                            `https://www.promptings.com/enterprisepacks${sponsorQuery}`,
                            '_blank',
                          )
                        }
                      }}
                    ></Flex>
                    {heroSectionFeatureChart.title &&
                      !isExclusiveTitle(heroSectionFeatureChart.title) && (
                        <Text
                          alignment="center"
                          type="largeBody"
                          weight="semiBold"
                          color="primaryHeading"
                          content={heroSectionFeatureChart.title}
                        />
                      )}
                    <motion.div
                      ref={heroToggleRef}
                      layout
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                      style={{
                        width: '100%',
                        position: 'sticky',
                        top: heroToggleStickyTop,
                        zIndex: 8,
                      }}
                    >
                      <Flex
                        justifyContent="center"
                        alignItems="center"
                        inset={{ top: 'x1', bottom: 'x1' }}
                        outset={{ bottom: '24px' }}
                        flexDirection={isMobile ? 'column' : 'row'}
                        columnGap={isMobile ? undefined : 'x2'}
                        rowGap={isMobile ? 'x1_5' : undefined}
                      >
                        <ExternalTogglePill
                          open={shouldShowAllHeroPlans}
                          backgroundColor="linear-gradient(to right, #9859FE, #5E12D8)"
                          showChevronBurst={showMoreChevronBurst}
                          chevronBurstDirection="down"
                          chevronBurstPlacement="above"
                          onClick={() => {
                            heroPrevTopRef.current =
                              heroToggleRef.current?.getBoundingClientRect()
                                .top ?? null
                            heroPendingRef.current = true
                            const isOpening = !shouldShowAllHeroPlans

                            if (heroToggleAnimationTimer.current) {
                              window.clearTimeout(
                                heroToggleAnimationTimer.current,
                              )
                            }

                            if (isOpening) {
                              setShowMoreChevronBurst(true)
                              heroToggleAnimationTimer.current =
                                window.setTimeout(
                                  () => setShowMoreChevronBurst(false),
                                  1000,
                                )
                            } else {
                              setShowMoreChevronBurst(false)
                            }

                            setShouldShowAllHeroPlans(prev => !prev)
                            if (isOpening) {
                              scrollToggleIntoView({
                                delay: toggleScrollDelay,
                                align: 'bottom',
                                offset: 36,
                              })
                            }
                          }}
                          openLabel="Hide More Options"
                          closedLabel="Show More Options"
                        />
                        <ExternalTogglePill
                          open={showHeroExclusiveFeatures}
                          onClick={() => {
                            heroPrevTopRef.current =
                              heroToggleRef.current?.getBoundingClientRect()
                                .top ?? null
                            heroPendingRef.current = true
                            const isOpening = !showHeroExclusiveFeatures

                            if (heroExclusiveAnimationTimer.current) {
                              window.clearTimeout(
                                heroExclusiveAnimationTimer.current,
                              )
                            }

                            if (isOpening) {
                              setShowExclusiveChevronBurst(true)
                              heroExclusiveAnimationTimer.current =
                                window.setTimeout(
                                  () => setShowExclusiveChevronBurst(false),
                                  1000,
                                )
                            } else {
                              setShowExclusiveChevronBurst(false)
                            }

                            setShowHeroExclusiveFeatures(prev => !prev)
                            if (isOpening) {
                              scrollToggleIntoView({
                                delay: toggleScrollDelay,
                                align: 'top',
                                offset: 24,
                              })
                            }
                          }}
                          openLabel="Hide Exclusive Features"
                          closedLabel="Show Exclusive Features"
                          showChevronBurst={showExclusiveChevronBurst}
                          chevronBurstPlacement="below"
                          chevronBurstDirection="up"
                        />
                      </Flex>
                    </motion.div>
                    <AnimatePresence initial={false}>
                      {showHeroExclusiveFeatures &&
                        heroSectionFeatureChart.featureValuesCol1 && (
                          <motion.div
                            key="hero-feature-chart"
                            layout
                            initial={{ opacity: 0, y: -8, height: 0 }}
                            animate={{ opacity: 1, y: 0, height: 'auto' }}
                            exit={{ opacity: 0, y: -8, height: 0 }}
                            transition={{ duration: 0.4, ease: 'easeInOut' }}
                            style={{
                              width: '100%',
                              overflow: 'hidden',
                            }}
                          >
                            <Flex
                              flexDirection="column"
                              alignItems="center"
                              justifyContent="center"
                              inset={{
                                horizontal: isMobile ? 'x0' : 'x6',
                                vertical: 'x3',
                              }}
                            >
                              <FeatureItemChart
                                columns={[
                                  {
                                    title: 'Full System Access Includes:',
                                    features:
                                      heroSectionFeatureChart.featureValuesCol1,
                                  },
                                  ...(heroSectionFeatureChart.featureValuesCol2
                                    ? [
                                        {
                                          title: 'Membership Features:',
                                          features:
                                            heroSectionFeatureChart.featureValuesCol2,
                                        },
                                      ]
                                    : []),
                                ]}
                              />
                              {heroPlanTiles.plantilesection.disclaimer && (
                                <Flex
                                  maxWidth="1272px"
                                  inset={{
                                    horizontal: isMobile ? 'x2' : 'x6',
                                  }}
                                >
                                  <Text
                                    outset={{ top: 'x1_5' }}
                                    alignment="center"
                                    type="footnote"
                                    content={
                                      heroPlanTiles.plantilesection.disclaimer
                                    }
                                  />
                                </Flex>
                              )}
                            </Flex>
                          </motion.div>
                        )}
                    </AnimatePresence>
                  </Section>
                )}
              </>
            )}
            {/* ------- Subscription Comparison Chart ----- */}
            {isComparisonChartEnabled && (
              <Section maxWidth={PRICING_SECTION_MAX_WIDTH} verticalInset="x2">
                <Flex
                  cursor="not-allowed"
                  width="100%"
                  justifyContent="center"
                  alignItems="center"
                  outset={{ bottom: 'x5' }}
                >
                  <Flex
                    backgroundColor={
                      shouldShowComparisonChart ? 'transparent' : '#404040'
                    }
                    style={
                      shouldShowComparisonChart
                        ? { border: '2px solid #404040' }
                        : {}
                    }
                    inset={{ horizontal: 'x3', vertical: 'x1_5' }}
                    borderRadius="circle"
                    cursor="pointer"
                    onClick={() =>
                      setShouldShowComparisonChart(!shouldShowComparisonChart)
                    }
                  >
                    <Text
                      alignment="center"
                      content={`${
                        shouldShowComparisonChart ? 'Hide' : 'View'
                      } Comparison Chart`}
                      color={
                        shouldShowComparisonChart
                          ? 'primaryHeading'
                          : 'inverseHeading'
                      }
                      type="body"
                    />
                    <Flex
                      alignItems="center"
                      justifyContent="center"
                      style={{
                        transform: shouldShowComparisonChart
                          ? 'rotate(90deg)'
                          : 'rotate(-90deg)',
                      }}
                    >
                      <QIcon
                        size="small"
                        name="chevron"
                        primaryColor={
                          shouldShowComparisonChart
                            ? 'primaryHeading'
                            : 'inverseHeadingText'
                        }
                      />
                    </Flex>
                  </Flex>
                </Flex>
                <Flex
                  overflowX="auto"
                  inset={{
                    bottom: `${shouldShowComparisonChart ? '20px' : 'x0'}`,
                  }}
                  height={shouldShowComparisonChart ? 'auto' : '0px'}
                >
                  <ComparisonChart
                    activePlans={activePlans}
                    tableFeature={Object.keys(tableFeatures) as FeatureType[]}
                    selectedPlanData={selectedPlanData}
                    setSelectedPlanData={setSelectedPlanData}
                  />
                </Flex>
              </Section>
            )}
            {isPlanLegacy && (
              <>
                <LegacyPlanTile planId={currentPlanId} />
              </>
            )}
          </GlassBackgroundContainer>
        </>
      )}
      {filteredPlanSections?.slice(1).map((section, index) => {
        const promoSectionInsertIndex = 1 // Place Promo section under premium packs section
        const sectionUiBlobs = section.plantilesection?.uiBlobs
          ? JSON.parse(section.plantilesection.uiBlobs)
          : null
        const sectionFeatureChart = section.plantilesection?.featureChart
          ? JSON.parse(section.plantilesection.featureChart)
          : null
        const blobType = sectionUiBlobs
          ? { blobStart: 'center', blobs: sectionUiBlobs }
          : undefined

        //TODO Need to add a field on the backend that allows us to determine if a section should be collapsed

        const isGratitudePackageSection = section.order === 3
        const isCustomPackageSection =
          section.plantilesection?.subtitle === 'Premium Add-ons'

        if (
          shouldHideStarterPackage &&
          section.plantilesection?.title === 'Add To Your Membership:'
        ) {
          return (
            <>
              <Section
                key="gratitude-impact-section"
                verticalInset="x3"
                horizontalInset="x1"
              >
                <Flex width="100%" justifyContent="center">
                  <Flex
                    width="100%"
                    maxWidth={
                      shouldUseTwoColumnImpactTiles ? '960px' : '1272px'
                    }
                    justifyContent="center"
                    flexWrap="wrap"
                    columnGap={shouldUseTwoColumnImpactTiles ? 'x1_5' : 'x3'}
                    rowGap={shouldUseTwoColumnImpactTiles ? 'x2' : 'x3'}
                  >
                    {GRATITUDE_IMPACT_TILES.map(tile => (
                      <Flex
                        key={tile.title}
                        flexDirection="column"
                        justifyContent="flex-start"
                        minWidth={
                          isMobile
                            ? '100%'
                            : shouldUseTwoColumnImpactTiles
                              ? 'calc(50% - 8px)'
                              : '260px'
                        }
                        maxWidth={
                          isMobile
                            ? '100%'
                            : shouldUseTwoColumnImpactTiles
                              ? 'calc(50% - 8px)'
                              : undefined
                        }
                        width={
                          isMobile
                            ? '100%'
                            : shouldUseTwoColumnImpactTiles
                              ? 'calc(50% - 8px)'
                              : undefined
                        }
                        inset={{
                          horizontal: shouldUseTwoColumnImpactTiles
                            ? 'x1'
                            : 'x2',
                          vertical: shouldUseTwoColumnImpactTiles ? 'x1' : 'x2',
                        }}
                      >
                        {/* Top: main PNG image */}
                        <Div
                          width="100%"
                          borderRadius="medium"
                          style={{ overflow: 'hidden' }}
                        >
                          <img
                            src={impactTileImages[tile.id]}
                            alt={tile.title}
                            style={{
                              display: 'block',
                              width: '100%',
                              height: 'auto',
                              maxHeight: 255,
                              objectFit: 'contain',
                              borderRadius: 12,
                            }}
                          />
                        </Div>
                        <Flex
                          flexDirection="column"
                          alignItems="center"
                          inset={{ vertical: 'x2' }}
                        >
                          <Div
                            width="62px"
                            height="62px"
                            borderRadius="circle"
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              background:
                                tile.id === 'instant_impact' ||
                                tile.id === 'lasting_keepsake' ||
                                tile.id === 'wider_reach' ||
                                tile.id === 'inner_growth'
                                  ? '#fff'
                                  : 'linear-gradient(135deg,#22D3EE 0%, #A855F7 100%)',
                            }}
                          >
                            {tile.id === 'instant_impact' && (
                              <div
                                ref={instantImpactRef}
                                style={{ width: 62, height: 62 }}
                              />
                            )}
                            {tile.id === 'lasting_keepsake' && (
                              <div
                                ref={lastingKeepsakeRef}
                                style={{ width: 62, height: 62 }}
                              />
                            )}
                            {tile.id === 'wider_reach' && (
                              <div
                                ref={widerReachRef}
                                style={{ width: 62, height: 62 }}
                              />
                            )}
                            {tile.id === 'inner_growth' && (
                              <div
                                ref={innerGrowthRef}
                                style={{ width: 62, height: 62 }}
                              />
                            )}
                          </Div>
                          <Div inset={{ top: 'x2' }}>
                            <img
                              src={impactTileTextImages[tile.id]}
                              alt={tile.title}
                              style={{
                                display: 'block',
                                width: '100%',
                                height: 'auto',
                                maxHeight: isMobile ? 70 : 80,
                                objectFit: 'contain',
                              }}
                            />
                          </Div>
                        </Flex>
                      </Flex>
                    ))}
                  </Flex>
                </Flex>
              </Section>
              {/* White spaces in paragraphs below are intentional. Please don't remove */}
              <Section maxWidth={PRICING_SECTION_MAX_WIDTH} verticalInset="x1">
                <Flex
                  flexDirection="column"
                  alignItems="center"
                  inset={{ horizontal: isMobile ? 'x1' : 'x3', vertical: 'x2' }}
                >
                  <Flex
                    flexDirection="column"
                    alignItems="flex-start"
                    inset={{
                      horizontal: isMobile ? 'x1' : 'x4',
                      vertical: 'x3',
                    }}
                    style={{
                      width: '100%',
                      maxWidth: 1000,
                    }}
                  >
                    <Text
                      type="body"
                      style={{
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: '#111827',
                      }}
                    >
                      • The Full Impact Package is designed to attach to any
                      membership and give you the full impact of the Promptings
                      Gratitude Platform.
                    </Text>
                    <Text
                      type="body"
                      style={{
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: '#111827',
                      }}
                    >
                      • Any membership of choice gives your gratitude
                      <strong
                        style={{ fontFamily: 'inherit', fontSize: 'inherit' }}
                      >
                        {' '}
                        Instant Impact
                      </strong>{' '}
                      with unlimited digital acts.
                    </Text>
                    <Text
                      type="body"
                      style={{
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: '#111827',
                      }}
                    >
                      • This Package starts you out with 30 Printed Cards
                      (stamps included — $120.00 value) giving you
                      <strong
                        style={{ fontFamily: 'inherit', fontSize: 'inherit' }}
                      >
                        {' '}
                        Lasting Keepsake
                      </strong>{' '}
                      with printed cards that last a lifetime.
                    </Text>
                    <Text
                      type="body"
                      style={{
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: '#111827',
                      }}
                    >
                      • The Package also creates
                      <strong
                        style={{ fontFamily: 'inherit', fontSize: 'inherit' }}
                      >
                        {' '}
                        Wider Reach
                      </strong>{' '}
                      with enough cards and a system expert ($137.00 value) to
                      help you expand your reach of gratitude throughout your
                      network.
                    </Text>
                    <Text
                      type="body"
                      style={{
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: '#111827',
                      }}
                    >
                      • You also receive our revolutionary Gratitude Journal
                      system ($117.00 value) that creates
                      <strong
                        style={{ fontFamily: 'inherit', fontSize: 'inherit' }}
                      >
                        {' '}
                        Inner Growth
                      </strong>{' '}
                      with gratitude-driven personal development.
                    </Text>
                    <Text
                      type="body"
                      style={{
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: '#111827',
                      }}
                    >
                      • And, you can help expand the gratitude movement as a
                      gratitude consultant where you show others how to dwell in
                      the energy of gratitude. This gives you a full year
                      consultant package for free ($99.00 value).
                    </Text>
                    <Text
                      type="body"
                      inset={{ top: 'x2' }}
                      style={{
                        fontSize: 14,
                        lineHeight: 1.6,
                        color: '#111827',
                      }}
                    >
                      If you are all in and want to transform your life and the
                      lives of others with gratitude, then this package is for
                      you. Go all in and let's expand this movement and bring
                      kindness back to the world.
                    </Text>
                  </Flex>
                </Flex>
              </Section>
            </>
          )
        }

        return (
          <React.Fragment key={index}>
            {section.plantilesection && (
              <SectionContainer key={index} blobType={blobType as BlobType}>
                <Flex
                  id={generateSectionId(section.plantilesection.order)}
                  flexDirection="column"
                  alignContent="center"
                  alignItems="center"
                  width="100%"
                >
                  {shouldOpenPlanUpsale && (
                    <PlanUpsale
                      selectedPlanId={selectedPlanData.id}
                      onClose={() => setShouldOpenPlanUpsale(false)}
                      isAddon={!isSubscription}
                    />
                  )}
                  {(() => {
                    const rawTitle = section.plantilesection.title
                    const shouldHideCaption =
                      rawTitle === 'Add To Your Membership:'
                    const caption = !shouldHideCaption ? rawTitle : undefined
                    const subtitle = section.plantilesection.subtitle?.trim()
                    const hasTitleContent =
                      (caption && caption.trim() !== '') ||
                      (subtitle && subtitle !== '')
                    if (!hasTitleContent) return null
                    return (
                      <Section
                        maxWidth={PRICING_SECTION_MAX_WIDTH}
                        verticalInset={isCustomPackageSection ? 'x2' : 'x3'}
                      >
                        <ContentBlock
                          caption={caption}
                          title={createBoldSentence(
                            section.plantilesection.subtitle,
                          )}
                          body={[section.plantilesection.description ?? '']}
                        />
                      </Section>
                    )
                  })()}
                  <Div outset="x3" width="100%">
                    <Div
                      style={{
                        display:
                          isGratitudePackageSection && !shouldShowGratitudePacks
                            ? 'none'
                            : 'block',
                      }}
                      width="100%"
                    >
                      {isCustomPackageSection ? (
                        <Section
                          maxWidth={PRICING_SECTION_MAX_WIDTH}
                          verticalInset="x2"
                        >
                          <Flex width="100%" justifyContent="center">
                            <Flex
                              width={isTablet ? '90%' : '960px'}
                              borderRadius="large"
                              overflow="hidden"
                              style={{
                                boxShadow: '0px 4px 16px rgba(0,0,0,0.08)',
                              }}
                              flexDirection={isTablet ? 'column' : 'row'}
                            >
                              <Flex
                                flexDirection="column"
                                width="100%"
                                flexGrow={1}
                                backgroundColor="#FFFFFF"
                                inset={{ horizontal: 'x4', vertical: 'x5' }}
                                rowGap="x2"
                                style={{
                                  minWidth: isTablet ? 'auto' : '380px',
                                }}
                              >
                                {isMobile ? (
                                  <Flex alignItems="center" flexDirection="row">
                                    <Icon
                                      name="multiple_cards"
                                      color="#E56B7E"
                                    />
                                    <Text
                                      type="subtitle"
                                      color="primaryHeading"
                                      content={
                                        section.plantilesection.description
                                      }
                                      style={{ fontSize: 20, marginLeft: 8 }}
                                    />
                                  </Flex>
                                ) : (
                                  <>
                                    <Flex>
                                      <Icon
                                        name="multiple_cards"
                                        color="#E56B7E"
                                      />
                                    </Flex>
                                    <Text
                                      type="subtitle"
                                      color="primaryHeading"
                                      content={
                                        section.plantilesection.description
                                      }
                                    />
                                  </>
                                )}
                                <Text
                                  outset={{ left: 'x2' }}
                                  type="title"
                                  color="primaryBody"
                                  weight="regular"
                                  style={
                                    isMobile
                                      ? {
                                          fontSize: 24,
                                        }
                                      : undefined
                                  }
                                >
                                  {(() => {
                                    const consultantPlanId =
                                      section.plantilesection?.planIds?.[0]?.id
                                    const consultantPlan =
                                      consultantPlanId && plans
                                        ? plans.find(
                                            plan =>
                                              plan.id === consultantPlanId,
                                          )
                                        : undefined
                                    return consultantPlan?.price?.description
                                  })()}
                                </Text>
                                <Flex
                                  width="100%"
                                  inset={{ top: 'x4' }}
                                  style={{ marginTop: 'auto' }}
                                  justifyContent="center"
                                >
                                  <Flex
                                    width="100%"
                                    maxWidth="300px"
                                    justifyContent="center"
                                    alignItems="center"
                                  >
                                    <Button
                                      title="Add to Cart"
                                      onClick={() => {
                                        const firstPlanId =
                                          section.plantilesection?.planIds?.[0]
                                            ?.id
                                        const variantId = firstPlanId
                                          ? saleorPlanDescriptions[firstPlanId]
                                              ?.saleorVariantId
                                          : undefined
                                        if (variantId) {
                                          addToCart(variantId)
                                        }
                                      }}
                                      fullWidth
                                      textColorOverride="#FFFFFF"
                                      backgroundColorOverride={
                                        GRATITUDE_CONSULTANT_GRADIENT
                                      }
                                    />
                                  </Flex>
                                </Flex>
                              </Flex>
                              <Flex
                                flexDirection="column"
                                justifyContent="center"
                                width="100%"
                                inset={{
                                  horizontal: isMobile ? 'x3' : 'x5',
                                  vertical: isMobile ? 'x3' : 'x5',
                                }}
                                rowGap={isMobile ? 'x1_5' : 'x2'}
                                style={{
                                  background: GRATITUDE_CONSULTANT_GRADIENT,
                                  color: '#FFFFFF',
                                }}
                              >
                                {(
                                  saleorPlanDescriptions[
                                    section.plantilesection?.planIds?.[0]
                                      ?.id as string
                                  ]?.details || []
                                ).map((d, i) => (
                                  <Flex
                                    key={`gratitude-feature-${i}`}
                                    alignItems="center"
                                  >
                                    <Icon
                                      name="v_check"
                                      color="#FFFFFF"
                                      size={isMobile ? 16 : 20}
                                    />
                                    <Text
                                      type={isMobile ? 'body' : 'largeBody'}
                                      color="accent"
                                      style={{
                                        color: '#FFFFFF',
                                        fontSize: isMobile ? 13 : undefined,
                                      }}
                                      outset={{ left: 'x1' }}
                                    >
                                      {d.detail}
                                    </Text>
                                  </Flex>
                                ))}
                              </Flex>
                            </Flex>
                          </Flex>
                        </Section>
                      ) : !shouldHideStarterPackage &&
                        section.plantilesection.title ===
                          'Add To Your Membership:' ? (
                        <Section
                          maxWidth={PRICING_SECTION_MAX_WIDTH}
                          verticalInset="x2"
                        >
                          <Flex width="100%" justifyContent="center">
                            <Flex
                              width={isTablet ? '90%' : '960px'}
                              borderRadius="large"
                              overflow="hidden"
                              style={{
                                boxShadow: '0px 4px 16px rgba(0,0,0,0.08)',
                              }}
                              flexDirection={isTablet ? 'column' : 'row'}
                            >
                              <Flex
                                flexDirection="column"
                                width="100%"
                                flexGrow={1}
                                backgroundColor="#FFFFFF"
                                inset={{ horizontal: 'x4', vertical: 'x5' }}
                                rowGap="x2"
                                style={{
                                  minWidth: isTablet ? 'auto' : '380px',
                                }}
                              >
                                {isMobile ? (
                                  <Flex alignItems="center" flexDirection="row">
                                    <Icon
                                      name="multiple_cards"
                                      color={
                                        starterPlan?.backgroundStartColor ??
                                        '#10B981'
                                      }
                                    />
                                    <Text
                                      type="subtitle"
                                      color="primaryHeading"
                                      content={
                                        (starterPlanId &&
                                          saleorPlanDescriptions[starterPlanId]
                                            ?.plan) ??
                                        STARTER_PACKAGE_LABEL
                                      }
                                      style={{ fontSize: 20, marginLeft: 8 }}
                                    />
                                  </Flex>
                                ) : (
                                  <>
                                    <Flex>
                                      <Icon
                                        name="multiple_cards"
                                        color={
                                          starterPlan?.backgroundStartColor ??
                                          '#10B981'
                                        }
                                      />
                                    </Flex>
                                    <Text
                                      type="subtitle"
                                      color="primaryHeading"
                                      content={
                                        (starterPlanId &&
                                          saleorPlanDescriptions[starterPlanId]
                                            ?.plan) ??
                                        STARTER_PACKAGE_LABEL
                                      }
                                    />
                                  </>
                                )}
                                {starterPlan?.price?.description && (
                                  <Text
                                    outset={{ left: 'x2' }}
                                    type="title"
                                    color="primaryBody"
                                    weight="regular"
                                    style={
                                      isMobile
                                        ? {
                                            fontSize: 24,
                                          }
                                        : undefined
                                    }
                                  >
                                    {starterPlan.price.description}
                                  </Text>
                                )}
                                <Flex
                                  width="100%"
                                  inset={{ top: 'x4' }}
                                  style={{ marginTop: 'auto' }}
                                  justifyContent="center"
                                >
                                  <Flex
                                    width="100%"
                                    maxWidth="300px"
                                    justifyContent="center"
                                    alignItems="center"
                                  >
                                    <Button
                                      title="Add to Cart"
                                      onClick={() => {
                                        const variantId = starterPlanId
                                          ? saleorPlanDescriptions[
                                              starterPlanId
                                            ]?.saleorVariantId
                                          : undefined
                                        if (variantId) {
                                          addToCart(variantId)
                                        }
                                      }}
                                      fullWidth
                                      textColorOverride="#FFFFFF"
                                      backgroundColorOverride={
                                        starterPlanGradient
                                      }
                                    />
                                  </Flex>
                                </Flex>
                              </Flex>
                              <Flex
                                flexDirection="column"
                                justifyContent="center"
                                width="100%"
                                inset={{ horizontal: 'x5', vertical: 'x5' }}
                                rowGap="x2"
                                style={{
                                  background: starterPlanGradient,
                                  color: '#FFFFFF',
                                }}
                              >
                                {(
                                  (starterPlanId &&
                                    saleorPlanDescriptions[starterPlanId]
                                      ?.details) ||
                                  []
                                ).map((d, i) => (
                                  <Flex
                                    key={`starter-feature-${i}`}
                                    alignItems="center"
                                  >
                                    <Icon
                                      name="v_check"
                                      color="#FFFFFF"
                                      size={20}
                                    />
                                    <Text
                                      type="largeBody"
                                      color="accent"
                                      style={{ color: '#FFFFFF' }}
                                      outset={{ left: 'x1' }}
                                    >
                                      {d.detail}
                                    </Text>
                                  </Flex>
                                ))}
                              </Flex>
                            </Flex>
                          </Flex>
                        </Section>
                      ) : (
                        <>
                          <Section maxWidth="1600px" verticalInset="x2">
                            <PlanTiles
                              planIds={
                                isGratitudePackageSection &&
                                gratitudePack100PlanId
                                  ? [
                                      { id: gratitudePack100PlanId },
                                      ...section.plantilesection.planIds.filter(
                                        planId =>
                                          planId.id !== gratitudePack100PlanId,
                                      ),
                                    ]
                                  : section.plantilesection.title ===
                                        'Add To Your Membership:' &&
                                      shouldHideStarterPackage
                                    ? section.plantilesection.planIds.filter(
                                        planId =>
                                          planId.id !== starterPlanId &&
                                          planId.id !== gratitudePack100PlanId,
                                      )
                                    : section.plantilesection.planIds
                              }
                              onSelect={plan => setSelPlan(plan)}
                              onProceedToCheckout={() =>
                                actions.checkoutOpenState(false)
                              }
                              layout="grid"
                            />
                          </Section>
                          {isGratitudePackageSection && (
                            <Flex
                              flexDirection="column"
                              alignItems="center"
                              justifyContent="center"
                              outset={{ top: 'x2' }}
                            >
                              <Text
                                alignment="center"
                                type="largeBody"
                                weight="semiBold"
                                color="primaryHeading"
                                content={section.plantilesection.description}
                                outset={{ bottom: 'x2' }}
                              />
                              <Button
                                backgroundColorOverride="linear-gradient(to right, #415F9C, #00E0E0)"
                                textColorOverride="#fff"
                                title="See Enterprise Plans"
                                onClick={() => {
                                  if (isGratitudePackageSection) {
                                    const sponsorQuery = sponsor
                                      ? `?sponsor=${sponsor.genealogyId.toString()}`
                                      : ''
                                    window.open(
                                      `https://www.promptings.com/enterprisepacks${sponsorQuery}`,
                                      '_blank',
                                    )
                                  }
                                }}
                              />
                            </Flex>
                          )}
                        </>
                      )}
                    </Div>
                  </Div>
                  {sectionFeatureChart && (
                    <Flex
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      inset={{
                        horizontal: isMobile ? 'x2' : 'x6',
                        vertical: 'x3',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          cursor: 'pointer',
                        }}
                        onMouseEnter={() =>
                          isGratitudePackageSection
                            ? setIsHovered(true)
                            : undefined
                        }
                        onMouseLeave={() =>
                          isGratitudePackageSection
                            ? setIsHovered(false)
                            : undefined
                        }
                        onClick={() => {
                          if (isGratitudePackageSection) {
                            const sponsorQuery = sponsor
                              ? `?sponsor=${sponsor.genealogyId.toString()}`
                              : ''
                            window.open(
                              `https://www.promptings.com/enterprisepacks${sponsorQuery}`,
                              '_blank',
                            )
                          }
                        }}
                      >
                        <motion.div
                          animate={
                            isGratitudePackageSection
                              ? {
                                  scale: isHovered ? 1.05 : 1,
                                  opacity: isHovered ? 0.8 : 1,
                                }
                              : undefined
                          }
                          transition={{ duration: 0.2, ease: 'easeOut' }}
                        >
                          {sectionFeatureChart.title &&
                            !isExclusiveTitle(sectionFeatureChart.title) && (
                              <Text
                                alignment="center"
                                type="largeBody"
                                weight="semiBold"
                                color="primaryHeading"
                                content={sectionFeatureChart.title}
                              />
                            )}
                        </motion.div>
                      </div>
                      {sectionFeatureChart.featureValuesCol1 && (
                        <FeatureItemChart
                          columns={[
                            {
                              features: sectionFeatureChart.featureValuesCol1,
                            },
                            ...(sectionFeatureChart.featureValuesCol2
                              ? [
                                  {
                                    features:
                                      sectionFeatureChart.featureValuesCol2,
                                  },
                                ]
                              : []),
                          ]}
                        />
                      )}
                    </Flex>
                  )}
                  {isGratitudePackageSection && shouldShowGratitudePacks && (
                    <Flex
                      maxWidth="1272px"
                      inset={{ horizontal: isMobile ? 'x2' : 'x6' }}
                    >
                      <Text
                        alignment="center"
                        type="footnote"
                        content={section.plantilesection.disclaimer}
                      />
                    </Flex>
                  )}
                </Flex>
              </SectionContainer>
            )}
            {promoSectionInsertIndex === index &&
              !currentPlanId &&
              !hasEverHadSamplePack &&
              !shouldHideFreeCard && (
                <Flex
                  id="04"
                  inset="64px"
                  width="100%"
                  backgroundColor="#F9FAFB"
                  justifyContent="center"
                  alignItems="center"
                  flexDirection="column"
                  columnGap="x4"
                  rowGap="x4"
                  style={{
                    boxShadow: 'inset 0 0 32px rgba(18, 18, 18, 0.12)',
                  }}
                >
                  <Text
                    alignment="center"
                    type="body"
                    content="Or have a sneak peek"
                    style={{
                      fontSize: isTablet ? 32 : 48,
                      fontWeight: '700',
                      lineHeight: 1.2,
                      color: '#404040',
                    }}
                  />
                  <Text
                    style={{
                      fontSize: isTablet ? 14 : 16,
                      fontWeight: '400',
                      lineHeight: 1.4,
                      color: '#404040',
                    }}
                    alignment="center"
                    type="body"
                    content="These are the perfect way for you to try out the product before committing to a membership or package."
                  />
                  <Flex
                    flexDirection={shouldStackPromoTile ? 'column' : 'row'}
                    columnGap="x4"
                    rowGap="x4"
                  >
                    {!currentPlanId && (
                      <PromoPlanTile
                        bulletPoints={[
                          '1 Card, Stamp Included*',
                          'Limited System Access',
                        ]}
                        type="FreeCard"
                        title="Free Card"
                        onClick={() => {
                          const baseUrl =
                            'https://app.sendoutcards.com/dashboard/account?postcardPromo&verify'
                          const url = sponsor?.genealogyId
                            ? `${baseUrl}&sponsor=${sponsor.genealogyId}`
                            : baseUrl
                          window.open(url, '_blank', 'noopener,noreferrer')
                        }}
                      />
                    )}
                  </Flex>
                  <Flex flexDirection="column">
                    <Text
                      alignment="center"
                      content="*Free Card – One-Time Use. Phone Number Required."
                      type="footnote"
                    />
                    <Text
                      alignment="center"
                      content="*All prices are in US Dollars. All cards include US stamps, international stamps will incur a $1 fee."
                      type="footnote"
                    />
                  </Flex>
                </Flex>
              )}
          </React.Fragment>
        )
      })}
      {shouldDisplayAffiliateBanner && (
        <Section maxWidth="1600px" verticalInset="x3">
          <SinglePlanTile
            id="06"
            action={{
              title: hasAffiliateSubscription
                ? `Congrats ${AFFILIATE_BRANDING.capitalized}!`
                : 'Join Now',
              onClick: () => console.log('Add product to cart'),
            }}
            isActivated={hasAffiliateSubscription}
          />
        </Section>
      )}
      {filteredGridSections && filteredGridSections.length > 0 && (
        <Section
          maxWidth="1600px"
          verticalInset="x3"
          horizontalInset={isMobile ? 'x2' : 'x4'}
        >
          <FeatureCardGridSection featureGrids={filteredGridSections} />
        </Section>
      )}
      {selPlan && (
        <DialogUpsaleCheckout
          selectedItem={selPlan}
          onSuccessClose={() => {
            setSelPlan(undefined)
          }}
          onClose={() => {
            setSelPlan(undefined)
          }}
        />
      )}
      <Section maxWidth="1600px" verticalInset="x3">
        <ContentBlock
          caption="Create genuine human connection with the"
          title={{ title: 'Store', bolded: 'Add-ons' }}
          body={[
            'Enhance your card sending creation by personalizing your account with your own handwriting font and signatures. ',
          ]}
        />
        <Div
          id="00"
          display="flex"
          width="100%"
          justifyContent="space-between"
          outset={{ top: 'x2', bottom: 'x7' }}
        >
          <AddOnTiles
            planIds={addOnTileIds}
            onPurchaseNow={() => actions.checkoutOpenState(true)}
          />
        </Div>
      </Section>
    </Flex>
  )
}
const isExclusiveTitle = (t?: string | null) =>
  (t ?? '').trim().toLowerCase() === 'exclusive features'
